<template>
  <section class="document-hero">
    <div class="document-hero__body">
      <div class="document-hero__text">
        <span class="document-hero__badge" v-html="getTitleBlock(page, 'hero-badge', 'title')"></span>
        <h1 class="document-hero__title" v-html="getTitleBlock(page, 'hero', 'title')"></h1>
        <p class="document-hero__description" v-html="getTitleBlock(page, 'hero', 'description')"></p>
        <ul class="document-hero__points">
          <li v-for="(point, index) in getListBlock(page, 'hero-points')" :key="index" class="document-hero__point">
            <span class="document-hero__point-icon"><CheckLineIcon :size="14" /></span>
            <span v-html="point"></span>
          </li>
        </ul>
      </div>
      <div class="document-hero__form" id="resources-form">
        <RequestForm
          :title="documentFormText('title')"
          :submit-label="documentFormText('submit')"
          :success-text="documentFormText('success-text')"
          show-document-picker
          :first-document="document.slug"
        />
      </div>
    </div>
  </section>
</template>

<script>
import RequestForm from '../../request-form';
import { textBlock } from '@/entities/text-block';
import { RESOURCES_HUB_TEXT_PAGE } from '@/features/agent-resources/config';
import { CheckLineIcon } from '@/shared/ui/icons';

export default {
  props: {
    document: {
      type: Object,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
  },
  mixins: [ textBlock ],
  components: { CheckLineIcon, RequestForm },
  methods: {
    documentFormText(key) {
      return this.getKeyValueListBlockValue(RESOURCES_HUB_TEXT_PAGE, 'document-form', key);
    },
  },
};
</script>

<style lang="scss" scoped>
.document-hero {
  max-width: 1328px;
  margin: 0 auto;
  padding: 72px 24px 0;

  @media (max-width: 800px) {
    padding: 32px 16px 0;
  }

  &__body {
    display: flex;
    flex-wrap: wrap;
    gap: 48px;
    align-items: center;
  }

  &__text {
    flex: 1 1 520px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  &__badge {
    padding: 10px 16px;
    border-radius: 14px;
    background: linear-gradient(100deg, #F5AB72, #EB8C42);
    box-shadow: 0 10px 24px rgba(235, 140, 66, 0.35);
    color: #373A3D;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    transform: rotate(-2deg);
  }

  &__title {
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(40px, 5.2vw, 68px);
    line-height: 1.08;
    color: #373A3D;

    ::v-deep span {
      background: linear-gradient(90deg, #4555CC, #CC5697 55%, #E67B53);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }
  }

  &__description {
    margin: 0;
    max-width: 520px;
    font-size: 19px;
    line-height: 28px;
    color: #4E5358;
  }

  &__points {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  &__point {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 18px;
    line-height: 26px;
  }

  &__point-icon {
    flex: none;
    width: 28px;
    height: 28px;
    border-radius: 999px;
    background: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &__form {
    flex: 1 1 400px;
    max-width: 482px;
    padding: 32px;
    border-radius: 28px;
    background: #FFFFFF;
    box-shadow: 0 16px 48px rgba(55, 58, 61, 0.10);

    @media (max-width: 800px) {
      max-width: none;
      padding: 24px;
    }
  }
}
</style>
